"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Navigation", {
  enumerable: true,
  get: function get() {
    return _navigation.Navigation;
  }
});
Object.defineProperty(exports, "WrapperContext", {
  enumerable: true,
  get: function get() {
    return _navigation.WrapperContext;
  }
});
Object.defineProperty(exports, "PageContent", {
  enumerable: true,
  get: function get() {
    return _navigation.PageContent;
  }
});
Object.defineProperty(exports, "DrawerContext", {
  enumerable: true,
  get: function get() {
    return _navigation.DrawerContext;
  }
});
Object.defineProperty(exports, "AccountContext", {
  enumerable: true,
  get: function get() {
    return _navigation.AccountContext;
  }
});
Object.defineProperty(exports, "withShellFocusNavigation", {
  enumerable: true,
  get: function get() {
    return _hocs.withShellFocusNavigation;
  }
});
Object.defineProperty(exports, "withShellEmptyNavigation", {
  enumerable: true,
  get: function get() {
    return _hocs.withShellEmptyNavigation;
  }
});
Object.defineProperty(exports, "withShellDefaultNavigation", {
  enumerable: true,
  get: function get() {
    return _hocs.withShellDefaultNavigation;
  }
});
Object.defineProperty(exports, "withCustomFocusNavigation", {
  enumerable: true,
  get: function get() {
    return _hocs.withCustomFocusNavigation;
  }
});
Object.defineProperty(exports, "withDefaultNavigation", {
  enumerable: true,
  get: function get() {
    return _hocs.withDefaultNavigation;
  }
});
Object.defineProperty(exports, "withDefaultSiteSelectorNavigation", {
  enumerable: true,
  get: function get() {
    return _hocs.withDefaultSiteSelectorNavigation;
  }
});
Object.defineProperty(exports, "withEmptyNavigation", {
  enumerable: true,
  get: function get() {
    return _hocs.withEmptyNavigation;
  }
});
Object.defineProperty(exports, "withEmptySiteSelectorNavigation", {
  enumerable: true,
  get: function get() {
    return _hocs.withEmptySiteSelectorNavigation;
  }
});
Object.defineProperty(exports, "withFocusNavigation", {
  enumerable: true,
  get: function get() {
    return _hocs.withFocusNavigation;
  }
});
Object.defineProperty(exports, "withFocusTabsNavigation", {
  enumerable: true,
  get: function get() {
    return _hocs.withFocusTabsNavigation;
  }
});
Object.defineProperty(exports, "withIframeNavigation", {
  enumerable: true,
  get: function get() {
    return _hocs.withIframeNavigation;
  }
});
Object.defineProperty(exports, "withTabsNavigation", {
  enumerable: true,
  get: function get() {
    return _hocs.withTabsNavigation;
  }
});
Object.defineProperty(exports, "withoutItemsNavigation", {
  enumerable: true,
  get: function get() {
    return _hocs.withoutItemsNavigation;
  }
});
Object.defineProperty(exports, "withBusinessSelectorNavigation", {
  enumerable: true,
  get: function get() {
    return _hocs.withBusinessSelectorNavigation;
  }
});
exports["default"] = exports.WithEmptySiteSelectorNavigation = void 0;

var _reactRedux = require("react-redux");

var _reactRouter = require("react-router");

var _navigation = require("./navigation");

var _hocs = require("./hocs");

var mapStateToProps = function mapStateToProps(state) {
  return {
    activePage: state.router.activePage,
    breadCrumb: state.router.breadCrumb,
    // pathToLeaveFocusView: state.router.pathToLeaveFocusView,
    // isFocusView: state.router.pathToLeaveFocusView !== undefined,
    isFocusView: state.router.activePage && state.router.activePage.isFocusView,
    hideNavBar: state.router.activePage && state.router.activePage.hideNav,
    subPages: state.router.activePage && state.router.activePage.subPages || [],
    hideBackButton: state.router.activePage && state.router.activePage.hideBackButton || false,
    // focusViewComponent: state.router.focusViewComponent,
    userFullName: state.auth.userFullName,
    userEmail: state.auth.userEmail,
    userColor: state.auth.userColor,
    isFreeAccount: state.auth.isFreeAccount,
    features: state.auth.getFeaturesInfoResponse,
    accountType: state.auth.accountType,
    authenticationMethod: state.auth.authenticationMethod // hideNavbar: state.router.hideNav
    // hideBackButton: state.router.hideBackButton

  };
}; // TODO: Lowercase export


var WithEmptySiteSelectorNavigation = _hocs.withEmptySiteSelectorNavigation;
exports.WithEmptySiteSelectorNavigation = WithEmptySiteSelectorNavigation;

var _default = (0, _reactRedux.connect)(mapStateToProps, null)((0, _reactRouter.withRouter)(_navigation.Navigation));

exports["default"] = _default;